import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Box, Tooltip, Fab } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';
import AddIcon from '@mui/icons-material/Add';

import Scrollbar from '../../../../components-core/Scrollbar';
import EmptyContent from '../../../../components-core/EmptyContent';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridToolbar } from '../../../../components-core/data-grid/DataGridToolbar';
import { purchaserColumns } from '../../../../services/column-definitions';
import PurchaserDetails from './PurchaserDetails';

export const PurchaserList = props => {
  const { onOpenSidebar, hideSidebar, purchasers, queryCallback, count, loading, submitCallback } = props;
  const [openCompose, setOpenCompose] = React.useState(false);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [rowsState, setRowsState] = React.useState({
    page: 0,
    pageSize: 10,
    rows: purchasers,
    loading: false
  });
  const [editRowData, setEditRowData] = React.useState(null);
  const isEmpty = 2 < 1;

  const handleDetailsCheck = data => {
    setEditRowData(data);
    setFullScreen(true);
    setOpenCompose(true);
  };

  const [columns, setColumns] = React.useState(purchaserColumns(handleDetailsCheck));

  React.useEffect(() => {
    setRowsState({ ...rowsState, rows: purchasers });
  }, [purchasers]);

  React.useEffect(() => {
    queryCallback(rowsState.page, rowsState.pageSize);
    setRowsState(prev => ({ ...prev, loading: false }));
  }, [rowsState.page, rowsState.pageSize]);

  React.useEffect(() => {
    const columnsClone = _.cloneDeep(columns);
    setColumns(columnsClone);
  }, []);

  const handleColumnVisibilityChange = useDebouncedCallback(
    col => {
      const columnsClone = _.cloneDeep(columns);
      const idx = _.findIndex(columns, obj => obj.field == col.field);
      columnsClone[idx].hide = !columnsClone[idx].hide;
      setColumns(columnsClone);
    },
    200
  );

  const searchCallback = search => {
    queryCallback(rowsState.page, rowsState.pageSize, search);
  };

  return (
    <Box sx={{ opacity: loading ? 0.5 : 1 }}>
      <PurchaserDetails
        isOpenCompose={openCompose}
        parentFullScreen={fullScreen}
        onCloseCompose={() => {
          setOpenCompose(false);
          setFullScreen(false);
          setEditRowData(null);
        }}
        submitCallback={submitCallback}
        data={editRowData}
      />
      <Box display="flex" justifyContent="center">
        <Tooltip title="Dodaj zamawiającego" sx={{ mb: 1 }}>
          <Fab
            color="primary"
            aria-label="add"
            onClick={() => {
              setFullScreen(true);
              setOpenCompose(true);
            }}
          >
            <AddIcon style={{ fontSize: '30px' }} />
          </Fab>
        </Tooltip>
      </Box>
      {!isEmpty ? (
        <Scrollbar>
          <Box sx={{ minWidth: { md: 800 } }}>
            <DataGridPro
              columns={columns}
              rows={rowsState.rows}
              density="compact"
              disableColumnMenu={true}
              autoPageSize={false}
              autoHeight={true}
              rowsPerPageOptions={[10, 25, 50, 100]}
              components={{
                Toolbar: DataGridToolbar
              }}
              componentsProps={{ toolbar: { onOpenSidebar, hideSidebar, miniView: true, searchCallback } }}
              localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
              // checkboxSelection
              disableSelectionOnClick
              onColumnVisibilityChange={col => handleColumnVisibilityChange(col)}
              pagination
              rowCount={count}
              {...rowsState}
              paginationMode="server"
              onPageChange={page => setRowsState(prev => ({ ...prev, page }))
              }
              onPageSizeChange={pageSize => setRowsState(prev => ({ ...prev, pageSize }))
              }
              onRowClick={params => {
                setEditRowData(params.row);
                setOpenCompose(true);
              }}
              onRowDoubleClick={params => {
                setEditRowData(params.row);
                setFullScreen(true);
                setOpenCompose(true);
              }}
            />
          </Box>
        </Scrollbar>
      ) : (
        <EmptyContent
          title="Brak zamawiających"
          img="https://minimal-assets-api.vercel.app/assets/illustrations/illustration_empty_mail.svg"
          sx={{ flexGrow: 1, height: 'auto' }}
        />
      )}
    </Box>
  );
};

PurchaserList.propTypes = {
  onOpenSidebar: PropTypes.func
};
